export default (theme) => ({
  termsContainer: {
    display: 'flex',
    background: theme.palette.background.white,
    flexDirection: 'column',
  },
  consentImg: {
    width: 250,
    objectFit: 'contain',
  },
  messageBox: {
    marginTop: 20,
    display: 'flex',
    alignItems: 'flex-start',
    flexDirection: 'column',
  },
  checkboxLabel: {
    lineHeight: '40px',
  },
  iAcceptBtn: {
    marginTop: 20,
    alignSelf: 'center',
  },
  title: {
    fontWeight: 700,
  },
  navigationButton: {
    backgroundColor: 'red',
  },
  marginTop20: {
    marginTop: 20,
  },
  h1Title: {
    fontSize: 22,
    fontWeight: 'bold',
    marginBottom: 10,
  },
});
